import { useEffect } from 'react';
import { FAQAccordion } from '../components/article/FAQAccordion';
import { faqItems } from '../data/faq';
import { canViewProfileContent } from '../lib/permissions';
import { PROFILE_LABEL, type Profile } from '../types/profile';

const PROFILE_ORDER: Profile[] = ['student', 'mentor', 'owner'];

export function FAQPage({ profile }: { profile: Profile }) {
  const visibleItems = faqItems.filter((item) => canViewProfileContent(profile, item.profile));
  const groups = PROFILE_ORDER
    .map((groupProfile) => ({
      profile: groupProfile,
      items: visibleItems.filter((item) => item.profile === groupProfile),
    }))
    .filter((group) => group.items.length > 0);

  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (!id) return;

    const target = document.getElementById(id);
    if (target instanceof HTMLDetailsElement) {
      target.open = true;
      requestAnimationFrame(() => target.scrollIntoView({ block: 'center' }));
    }
  }, [profile]);

  return (
    <main className="page-shell faq-page">
      <header className="faq-page-heading">
        <p className="eyebrow">Perguntas frequentes</p>
        <h1>Dúvidas rápidas</h1>
        <p className="lead">
          Respostas disponíveis para {PROFILE_LABEL[profile]}. Perfis com maior alçada também recebem as dúvidas dos perfis que herdam.
        </p>
      </header>

      {groups.map((group) => (
        <section className="faq-group" key={group.profile} aria-labelledby={`faq-group-${group.profile}`}>
          <h2 id={`faq-group-${group.profile}`}>{PROFILE_LABEL[group.profile]}</h2>
          <div className="faq-list" aria-label={`Perguntas frequentes — ${PROFILE_LABEL[group.profile]}`}>
            {group.items.map((item) => <FAQAccordion key={item.id} item={item} profile={profile} />)}
          </div>
        </section>
      ))}
    </main>
  );
}
